// /**
//  * Try to use separate files in /components/
//  *
//  * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
//  * Since it is only registered in actions.php
//  */

import './components/breakpoint-change';
import './components/fancybox';
import Navigation from './components/navigation';
import AlertBar from './components/alert-bar';
import Video from './components/video';
import AnchorSelect from './components/anchor-select';
import Accordion from './components/accordion';
import OffCanvas from './components/offcanvas';
import Details from './components/details';
import FooterMenu from './components/footer-menu';
import { registerComponent } from './helpers';

window.addEventListener('DOMContentLoaded', () => {
	registerComponent('.navigation:not(.invisible)', Navigation);
	registerComponent('.alert-bar', AlertBar);
	registerComponent('.js-video', Video);
	registerComponent('.js-anchor-select', AnchorSelect);
	registerComponent('.accordion', Accordion);
	registerComponent('details', Details);
	registerComponent('.widget_nav_menu', FooterMenu);

	document.querySelectorAll('.off-canvas').forEach((elem) => {
		const id = elem.getAttribute('id');
		const openBtn =
			id === 'main-navigation'
				? document.querySelector('.navigation > .navigation-bar .off-canvas-toggle')
				: document.querySelector(`.off-canvas-toggle[data-target="${id}"]`);
		new OffCanvas(elem, openBtn);
	});

	// Open accordion/details element when URL hash matches its ID
	function openAccordionFromHash() {
		if (!window.location.hash) {
			return;
		}

		const hash = window.location.hash.substring(1); // Remove the #
		const targetElement = document.getElementById(hash);

		if (targetElement && targetElement.tagName === 'DETAILS') {
			targetElement.open = true;
			setTimeout(() => {
				const yOffset = -150;
				const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({ top: y, behavior: 'smooth' });
			}, 100);
		}
	}

	openAccordionFromHash();

	window.addEventListener('hashchange', openAccordionFromHash);

	// Anchor menu: show "back to menu" button when menu has scrolled out of view
	const anchorMenu = document.getElementById('anchor-menu');
	const anchorMenuBack = document.querySelector('.js-anchor-menu-back');
	if (anchorMenu && anchorMenuBack) {
		const scrollContainers = [window, ...document.querySelectorAll('[data-scroll-container]')];
		function updateAnchorMenuBack() {
			const rect = anchorMenu.getBoundingClientRect();
			const isMenuAboveViewport = rect.bottom < 80;
			anchorMenuBack.classList.toggle('is-visible', isMenuAboveViewport);
		}
		scrollContainers.forEach((el) => {
			el.addEventListener('scroll', updateAnchorMenuBack, { passive: true });
		});
		window.addEventListener('resize', updateAnchorMenuBack);
		updateAnchorMenuBack();
		anchorMenuBack.addEventListener('click', () => {
			anchorMenu.scrollIntoView({ behavior: 'smooth', block: 'start' });
		});
	}
});

window.addEventListener('DOMContentLoaded', function () {
	window.CBG = window.CBG || {};

	window.CBG.openMagazineLoginPopup = function (redirectTo) {
		localStorage.setItem('cbg_after_login_redirect', redirectTo);
		document.cookie = 'cbg_after_login_redirect=' + encodeURIComponent(redirectTo) + ';path=/';

		const popup = document.querySelector('.cbg-login-popup');
		if (!popup) return;

		popup.classList.add('active');
		popup.classList.remove('pointer-events-none', 'opacity-0', 'translate-y-16');

		if (!window.CBG.popupSwiper) {
			window.CBG.popupSwiper = new Swiper('.cbg-login-swiper', {
				allowTouchMove: false,
				effect: 'fade',
				fadeEffect: { crossFade: true },
			});
		}
	};

	const blocker = document.querySelector('.cbg-magazine-login-blocker');
	if (blocker && blocker.dataset.loginRequired === '1') {
		window.CBG.openMagazineLoginPopup('/');
	}

	document.addEventListener('click', async function (e) {
		if (e.target.closest('.cbg-login-close')) {
			const popup = document.querySelector('.cbg-login-popup');
			if (popup) {
				popup.classList.remove('active');
				popup.classList.add('pointer-events-none', 'opacity-0', 'translate-y-16');
			}
			return;
		}

		const loginBtn = e.target.closest('.cbg-login-btn[data-login="1"]');
		if (loginBtn) {
			let redirectTo =
				localStorage.getItem('cbg_after_login_redirect') ||
				document.cookie.replace(/(?:(?:^|.*;\s*)cbg_after_login_redirect\s*=\s*([^;]*).*$)|^.*$/, '$1');

			if (!redirectTo) redirectTo = '/';

			const res = await fetch(
				'/wp-admin/admin-ajax.php?action=strl_cbg_get_login_url&redirect_to=' + encodeURIComponent(redirectTo)
			);

			const data = await res.json();
			if (data.url) window.location.href = data.url;

			return;
		}
	});

	const links = document.querySelectorAll('a[href*="/gen-magazine/read/"]');

	links.forEach((link) => {
		link.addEventListener('click', async function (e) {
			if (e.metaKey || e.ctrlKey || e.shiftKey) return true;

			e.preventDefault();
			const target = this.getAttribute('href');

			const req = await fetch('/wp-admin/admin-ajax.php?action=strl_cbg_check_access', {
				credentials: 'same-origin',
			});
			const data = await req.json();

			if (data.logged_in === true) {
				window.location.href = target;
			} else {
				window.CBG.openMagazineLoginPopup(target);
			}
		});
	});
});
